import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { landingSchema, LandingFormValues } from "@modules/landings/validations/landingSchema";
import { useCreateLandingMutation } from "@modules/landings/services/mutations";

export function useLandingCreateForm() {
  const { mutateAsync, isPending } = useCreateLandingMutation();

  const methods = useForm<LandingFormValues>({
    resolver: zodResolver(landingSchema()),
    defaultValues: {
      "metadata.buttonRegisterName": "Registro",
      "metadata.subscription": true,
      "metadata.profileEdit": true,
      "metadata.buttonCpfName": "CPF/CNPJ Vinculado",
      "metadata.benefitsName": "Benefícios e SVAs",
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
